import React from 'react';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { message, Space, Table, Pagination, Tag, Row, Col, Form, Input, Divider, Tooltip, Button, Popconfirm, Upload } from 'antd';
import { FolderOpenOutlined, FolderOutlined, GroupOutlined, CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';
import CustomEmpty from "components/CustomEmpty";
import CustomBadge from 'components/CustomBadge';
import * as documentFunction from 'components/UIBuilder/SectionFunction/Document';
const { Dragger } = Upload;

export default class SignatureForm extends React.Component {
  constructor(props) {
    super();
    this.state = {
      fileList: [],
      signaturePreview: null,
    }
  };

  render() {
    const signatureImgUrl = this.props.parentFormComponent.state.formData.Signature !== undefined && this.props.parentFormComponent.state.formData.Signature !== null ? 'data:image/png;base64, ' + this.props.parentFormComponent.state.formData.Signature : '';
    const signaturePreviewImgUrl = this.state.signaturePreview !== null ? 'data:image/png;base64, ' + this.state.signaturePreview : '';
    return (
      <div style={{ marginLeft: '-15px', marginRight: '-15px' }}>
        <div style={{ marginBottom: '10px' }}><b>Signature Image</b></div>
        <Form.Item
          label=""
          labelCol={{ span: 0 }}
          wrapperCol={{ span: 24 }}
          name="file"
        >
          <Dragger
            name="file"
            accept=".png"
            multiple={false}
            fileList={this.state.fileList}
            onRemove={(file) => {
              this.setState({ fileList: [], signaturePreview: null });
              setTimeout(() => {
                this.props.parentFormComponent.formRef.current?.setFieldValue('file', undefined);
              }, config.setTimeoutMilliSecond);
            }}
            beforeUpload={(file) => {
              let extension = globalFunction.getExtension(file.name).toLowerCase();
              if (extension === '.png') {
                if (file.size <= 200 * 1024) {
                  let fileList = [];
                  fileList.push(file);
                  this.setState({ fileList });
                  let that = this;
                  let reader = new FileReader();
                  reader.onloadend = function (evt) {
                    if (evt.target.readyState === FileReader.DONE) {
                      let arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);

                      let signaturePreview = btoa(
                        array.reduce((data, byte) => data + String.fromCharCode(byte), '')
                      );
                      that.setState({ signaturePreview });
                    }
                  };
                  reader.readAsArrayBuffer(file);
                } else {
                  message.warning('File ' + file.name + ' more than 200KB');
                }
              } else {
                message.warning('You mast select a PNG file');
              }
              return false;
            }}
          >
            <p className="ant-upload-drag-icon">
              {this.state.signaturePreview !== '' ? <img style={{ height: '100px' }} src={signaturePreviewImgUrl} /> : <></>}
            </p>
            <p className="ant-upload-text">Drag and drop a signature image here, or click to select.</p>
            <p className="ant-upload-hint">
              File size limits to 200KB. PNG image with transparent background is recommended.
            </p>
          </Dragger>
        </Form.Item>
      </div>
    )
  }
}
